module.exports = __webpack_public_path__ + "static/media/TotalLineItems.95933a0d.svg";